// Tracking ImageWithPlaceholder.js
import React, { useState } from 'react';

/**
 * Simple image component with loading placeholder
 * Simplified to just show skeleton until image loads
 */
export default function ImageWithPlaceholder({ 
  src, 
  alt, 
  className = '',
  ...props 
}) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="relative w-full h-full">
      {/* Skeleton - shown until image loads */}
      {!loaded && (
        <div 
          className={className}
          style={{
            background: 'linear-gradient(90deg, #f5f1ec 0%, #e8dfd3 20%, #f5f1ec 40%, #f5f1ec 100%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 1.8s ease-in-out infinite'
          }}
        />
      )}
      
      {/* Image - always rendered, just hidden until loaded */}
      <img
        src={src}
        alt={alt}
        className={`${className} ${loaded ? 'opacity-100' : 'opacity-0'}`}
        onLoad={() => setLoaded(true)}
        {...props}
      />

      {/* Shimmer animation */}
      <style>{`
        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
    </div>
  );
}
